import Cookies from 'js-cookie'
import { User } from 'src/apis'
import { useSettingsStore } from 'Store/settings'
import { SessionStorageKeys } from 'javascript/Constants'

function getHotelDomain() {
  const domainList = window.location.host.split('.')
  if (domainList.length > 2) {
    domainList.shift()
    return domainList.join('.')
  }
  return null
}

const getTriplaUIDCookieDomain = () =>
  TARGET_ENV === 'production' ? window.location.host : getHotelDomain()

export function setTriplaUID(triplaUID) {
  if (triplaUID && triplaUID !== Cookies.get('client_tripla_uid')) {
    Cookies.set('client_tripla_uid', triplaUID, {
      domain: getTriplaUIDCookieDomain()
    })
  }
}

export function getTriplaUID() {
  const settingsStore = useSettingsStore()
  return settingsStore.isFirstPartyDomainEnable ? Cookies.get('client_tripla_uid') : null
}

export function removeTriplaUID() {
  Cookies.remove('client_tripla_uid', {
    domain: getTriplaUIDCookieDomain()
  })
}

export function tryGetStoredSession() {
  const settingsStore = useSettingsStore()
  if (!settingsStore.isFirstPartyDomainEnable) {
    return
  }

  return User.TriplaUID().catch((e) => console.error(e))
}
